module.exports = __webpack_public_path__ + "static/media/group_guide_img_2_m.ad0b58eb.png";